import { render, staticRenderFns } from "./FesHechosInfo.vue?vue&type=template&id=33b1b1cc"
import script from "./FesHechosInfo.vue?vue&type=script&lang=js"
export * from "./FesHechosInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33b1b1cc')) {
      api.createRecord('33b1b1cc', component.options)
    } else {
      api.reload('33b1b1cc', component.options)
    }
    module.hot.accept("./FesHechosInfo.vue?vue&type=template&id=33b1b1cc", function () {
      api.rerender('33b1b1cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/info_procesos/FesHechosInfo.vue"
export default component.exports